import { useEffect, useState } from 'react';
import { ResetPasswordForm } from '~/components/admin/ResetPasswordForm';
import { supabase } from '~/lib/supabase-browser';

function ResetPasswordPage() {
  const [recoveryReady, setRecoveryReady] = useState(false);
  const [recoveryError, setRecoveryError] = useState('');

  useEffect(() => {
    let cancelled = false;

    async function prepareRecoverySession() {
      const hash = new URLSearchParams(window.location.hash.slice(1));
      const accessToken = hash.get('access_token');
      const refreshToken = hash.get('refresh_token');

      // createBrowserClient intentionally uses PKCE for cookie sessions, while
      // admin-generated and some legacy recovery links carry an implicit token
      // pair. Verify that pair through Supabase, persist the resulting cookie
      // session, and immediately remove the credentials from the address bar.
      if (hash.get('type') === 'recovery' && accessToken && refreshToken) {
        const { error } = await supabase.auth.setSession({
          access_token: accessToken,
          refresh_token: refreshToken,
        });
        if (cancelled) return;
        if (error) {
          setRecoveryError(error.message || 'This password reset link is invalid or expired.');
          return;
        }
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${window.location.search}`);
      }

      if (!cancelled) setRecoveryReady(true);
    }

    void prepareRecoverySession();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50">
      <div className="w-full max-w-sm p-6 bg-white rounded-lg shadow-sm border border-gray-200">
        <h1 className="text-xl font-bold text-gray-900 mb-6 text-center">
          Reset Password
        </h1>
        {recoveryError ? (
          <div className="text-sm text-red-600 bg-red-50 px-3 py-2 rounded">
            {recoveryError}
          </div>
        ) : recoveryReady ? (
          <ResetPasswordForm />
        ) : (
          <div className="text-sm text-gray-600 text-center">Preparing your reset link...</div>
        )}
      </div>
    </div>
  );
}

export default ResetPasswordPage;
